import { render } from "./CatDropdown.vue?vue&type=template&id=3ddf0291"
import script from "./CatDropdown.vue?vue&type=script&lang=js"
export * from "./CatDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/Users/n0m4dz/workspace/projects/btv-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__